// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.column-area {
  margin: 25px 0;
}

.profile_main .body-scroll {
  display: block;
  max-height: 330px;
  overflow-y: auto;
  margin-top: 0;
}

.profile_main thead {
  display: table;
  width: calc(100% - 7px);
  /*width: 100%;*/
}
.download-link {
  color: #7a2df9;
  text-decoration: underline;
  cursor: pointer;
  font-size: 12px;
}
.profile_main th,
.profile_main td {
  /*width: 33.33%;*/
  word-break: break-all;
  /*min-width: 250px;*/
  width: 250px;
}

.profile_main tr {
  display: table;
  width: 100%;
  box-sizing: border-box;
}

.profile_main .title-img-area img {
  max-width: 200px;
  width: 100%;
  object-fit: cover;
  border-radius: 8px;
}

.profile_main .title-img-area h5 {
  font-weight: 400;
  font-size: 16px;
  text-align: center;
  color: #0f062b;
  padding-top: 15px;
}

.profile_main .titleed h4 {
  font-weight: 700;
  font-size: 28px;
  color: #0f062b;
  margin-bottom: 0;
}

.profile_main .p-name {
  cursor: pointer;
}

.profile_main .table2 {
  background: #ffffff;
  border: 1px solid #f8f8f8;
  border-radius: 8px;
}

.profile_main.profile-list table {
  border-spacing: 0;
  margin-bottom: 0;
}
.profile_main.profile-list table thead tr th:first-child,
.profile_main.profile-list table tbody tr td:first-child{
  width: 30%;
}
.profile_main.profile-list table thead tr th {
  border-bottom: 1px solid #f5f1fc !important;
}

.profile_main.profile-list table thead tr th:not(:last-child) {
  border-right: 1px solid #f5f1fc !important;
}

.profile_main.profile-list table tbody tr td {
  border-bottom: 1px solid #f5f1fc !important;
  vertical-align: middle;
}

.profile_main.profile-list table tbody tr td:not(:last-child) {
  border-right: 1px solid #f5f1fc !important;
}

.profile_main.profile-list table .body-scroll tr:nth-last-child(2) td {
  border-bottom: none !important;
}

.profile_main.profile-list table tbody tr:last-child td {
  border-bottom: none !important;
}

.profile_main.profile-list table .tfoot th .footer-th {
  background: #f9f8fb;
}

.profile_main.profile-list table .tfoot th .footer-th span {
  font-weight: 700;
  font-size: 20px;
  color: #0f062b;
}

.profile_main.profile-list table .tfoot th:first-child .footer-th {
  border-radius: 8px 0 0 8px;
}

.profile_main.profile-list table .tfoot th:last-child .footer-th {
  border-radius: 0 8px 8px 0;
}

.profile_main.profile-list table .tfoot th {
  padding: 0;
}

.opacity {
  opacity: 0;
}

.profile-image {
  margin: 0;
  width: 35px;
  height: 35px;
  color: #ffffff !important;
  border-radius: 6px;
}

.profile_main.profile-list table tbody tr td .gap-3 {
  gap: 1rem!important;
  /* padding-left: 3rem; */
}

.profile_main.profile-list table tbody tr td .img-area img {
  border-radius: 6px;
  width: 35px;
  min-width: 35px;
  height: 35px;
  object-fit: cover;
}

.profile_main.profile-list table tbody tr td .img-area p {
  margin-bottom: 0;
  font-size: 14px;
  color: #7a2df9;
}

.profile_main.profile-list table tbody tr td span {
  font-weight: 400;
  font-size: 14px;
  color: #312545;
}

.w-100px{
  width: 100px !important;
}
@media (max-width:1200px) {

  .profile_main th,
  .profile_main td {
    min-width: 200px;
  }
  .profile_main.profile-list table thead tr th:first-child,
  .profile_main.profile-list table tbody tr td:first-child{
    min-width: 250px;
    width: auto;
  }
  .profile_main.profile-list table tbody tr td .gap-3 {
    padding-left: 0;
  }
}
@media (max-width: 768px) {
  .profile_main .title-img-area img {
    max-width: 300px;
  }
}

@media (max-width: 540px) {
  .profile_main .titleed h4 {
    font-size: 26px;
  }
}


`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/group/group-detail/group-detail.component.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,eAAe;AACjB;AACA;;EAEE,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;EAEE,UAAU;AACZ;AACA;EACE,2CAA2C;AAC7C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;AACA;;EAEE;;IAEE,gBAAgB;EAClB;EACA;;IAEE,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".column-area {\n  margin: 25px 0;\n}\n\n.profile_main .body-scroll {\n  display: block;\n  max-height: 330px;\n  overflow-y: auto;\n  margin-top: 0;\n}\n\n.profile_main thead {\n  display: table;\n  width: calc(100% - 7px);\n  /*width: 100%;*/\n}\n.download-link {\n  color: #7a2df9;\n  text-decoration: underline;\n  cursor: pointer;\n  font-size: 12px;\n}\n.profile_main th,\n.profile_main td {\n  /*width: 33.33%;*/\n  word-break: break-all;\n  /*min-width: 250px;*/\n  width: 250px;\n}\n\n.profile_main tr {\n  display: table;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.profile_main .title-img-area img {\n  max-width: 200px;\n  width: 100%;\n  object-fit: cover;\n  border-radius: 8px;\n}\n\n.profile_main .title-img-area h5 {\n  font-weight: 400;\n  font-size: 16px;\n  text-align: center;\n  color: #0f062b;\n  padding-top: 15px;\n}\n\n.profile_main .titleed h4 {\n  font-weight: 700;\n  font-size: 28px;\n  color: #0f062b;\n  margin-bottom: 0;\n}\n\n.profile_main .p-name {\n  cursor: pointer;\n}\n\n.profile_main .table2 {\n  background: #ffffff;\n  border: 1px solid #f8f8f8;\n  border-radius: 8px;\n}\n\n.profile_main.profile-list table {\n  border-spacing: 0;\n  margin-bottom: 0;\n}\n.profile_main.profile-list table thead tr th:first-child,\n.profile_main.profile-list table tbody tr td:first-child{\n  width: 30%;\n}\n.profile_main.profile-list table thead tr th {\n  border-bottom: 1px solid #f5f1fc !important;\n}\n\n.profile_main.profile-list table thead tr th:not(:last-child) {\n  border-right: 1px solid #f5f1fc !important;\n}\n\n.profile_main.profile-list table tbody tr td {\n  border-bottom: 1px solid #f5f1fc !important;\n  vertical-align: middle;\n}\n\n.profile_main.profile-list table tbody tr td:not(:last-child) {\n  border-right: 1px solid #f5f1fc !important;\n}\n\n.profile_main.profile-list table .body-scroll tr:nth-last-child(2) td {\n  border-bottom: none !important;\n}\n\n.profile_main.profile-list table tbody tr:last-child td {\n  border-bottom: none !important;\n}\n\n.profile_main.profile-list table .tfoot th .footer-th {\n  background: #f9f8fb;\n}\n\n.profile_main.profile-list table .tfoot th .footer-th span {\n  font-weight: 700;\n  font-size: 20px;\n  color: #0f062b;\n}\n\n.profile_main.profile-list table .tfoot th:first-child .footer-th {\n  border-radius: 8px 0 0 8px;\n}\n\n.profile_main.profile-list table .tfoot th:last-child .footer-th {\n  border-radius: 0 8px 8px 0;\n}\n\n.profile_main.profile-list table .tfoot th {\n  padding: 0;\n}\n\n.opacity {\n  opacity: 0;\n}\n\n.profile-image {\n  margin: 0;\n  width: 35px;\n  height: 35px;\n  color: #ffffff !important;\n  border-radius: 6px;\n}\n\n.profile_main.profile-list table tbody tr td .gap-3 {\n  gap: 1rem!important;\n  /* padding-left: 3rem; */\n}\n\n.profile_main.profile-list table tbody tr td .img-area img {\n  border-radius: 6px;\n  width: 35px;\n  min-width: 35px;\n  height: 35px;\n  object-fit: cover;\n}\n\n.profile_main.profile-list table tbody tr td .img-area p {\n  margin-bottom: 0;\n  font-size: 14px;\n  color: #7a2df9;\n}\n\n.profile_main.profile-list table tbody tr td span {\n  font-weight: 400;\n  font-size: 14px;\n  color: #312545;\n}\n\n.w-100px{\n  width: 100px !important;\n}\n@media (max-width:1200px) {\n\n  .profile_main th,\n  .profile_main td {\n    min-width: 200px;\n  }\n  .profile_main.profile-list table thead tr th:first-child,\n  .profile_main.profile-list table tbody tr td:first-child{\n    min-width: 250px;\n    width: auto;\n  }\n  .profile_main.profile-list table tbody tr td .gap-3 {\n    padding-left: 0;\n  }\n}\n@media (max-width: 768px) {\n  .profile_main .title-img-area img {\n    max-width: 300px;\n  }\n}\n\n@media (max-width: 540px) {\n  .profile_main .titleed h4 {\n    font-size: 26px;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
